import { render, staticRenderFns } from "./CustomerTurnover.vue?vue&type=template&id=76b5226c&scoped=true&"
import script from "./CustomerTurnover.vue?vue&type=script&lang=js&"
export * from "./CustomerTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b5226c",
  null
  
)

export default component.exports